import {
  GET_RESULTS,
  SET_RESULTS,
  SET_RENDERED_RESULTS,
  RESET_FILTERED_RESULTS,
  SET_FILTERED_RESULTS,
  ERROR_RESULTS,
  GET_SEARCH_RESULTS,
  SEARCH_BUSY,
  SEARCH_NOTBUSY,
  SET_SEARCH_TEXT,
} from "./types";
import { clearFilters, filterResults } from "./filters";
import axios from "axios";
import { config } from "./helpers";
import handleGA, { gaEvents } from "../googleAnalytics";

const api = process.env.REACT_APP_API;

export const setFilteredResults = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SET_FILTERED_RESULTS,
      payload: data,
    });
  } catch (error) {
    const msg = { msg: "Unable to set results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};

export const setRenderedResults = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SET_RENDERED_RESULTS,
      payload: data,
    });
  } catch (error) {
    const msg = { msg: "Unable to set results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};

export const setResults = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SET_RESULTS,
      payload: data,
    });
  } catch (error) {
    const msg = { msg: "Unable to set results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};

export const getResults = () => async (dispatch) => {
  try {
    dispatch({
      type: SEARCH_BUSY,
      payload: null,
    });
    const res = await axios.get(`${api}results`, config);
    dispatch({
      type: GET_RESULTS,
      payload: res.data,
    });
    dispatch(filterResults());
    dispatch({
      type: SEARCH_NOTBUSY,
      payload: null,
    });
    return res.status;
  } catch (error) {
    const msg = { msg: "Unable to get results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
    return 500;
  }
};

export const resetFilteredResults = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_FILTERED_RESULTS,
      payload: null,
    });
  } catch (error) {
    const msg = { msg: "Unable to set results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};

export const setSearchText = (searchText) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SEARCH_TEXT,
      payload: searchText,
    });
  } catch (error) {
    const msg = { msg: "Unable to set search text", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};

export const getSearchResults = (searchText) => async (dispatch) => {
  try {
    dispatch({
      type: SEARCH_BUSY,
      payload: null,
    });
    if (typeof searchText === "string" && searchText.length > 0) {
      handleGA(gaEvents.SEARCH_THE_LIBRARY, `${searchText}`);
      const res = await axios.get(`${api}search/?query=${searchText}`, config);
      dispatch({
        type: GET_SEARCH_RESULTS,
        payload: res.data,
      });
      dispatch(setSearchText(searchText));
      dispatch(filterResults());
    } else {
      dispatch(getResults());
      dispatch(setSearchText(""));
    }
    dispatch({
      type: SEARCH_NOTBUSY,
      payload: null,
    });
  } catch (error) {
    dispatch({
      type: SEARCH_NOTBUSY,
      payload: null,
    });
    const msg = { msg: "Unable to search for results", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_RESULTS,
      payload: msg,
    });
  }
};
